import { useState } from 'react';
import { motion } from 'framer-motion';
import { FileText, GitBranch, ListChecks, Book, Square } from 'lucide-react';
import { PreviewTabs } from './preview-tabs';
import { PreviewContent } from './preview-content';
import { VideoSidebar } from './video-sidebar';
import { DownloadSidebar } from './download-sidebar';

const tabs = [
  { id: 'notes', label: 'Smart Notes', icon: FileText },
  { id: 'mindmap', label: 'Mind Map', icon: GitBranch },
  { id: 'quiz', label: 'MCQ Quiz', icon: ListChecks },
  { id: 'glossary', label: 'Glossary', icon: Book },
  { id: 'flashcards', label: 'Flashcards', icon: Square },
];

export function PreviewSection() {
  const [activeTab, setActiveTab] = useState('notes');

  return (
    <section className="bg-white py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
            Preview Your Study Materials
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Explore different formats of your generated study materials
          </p>
        </motion.div>
        <div className="mt-16 grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-3">
            <VideoSidebar />
          </div>
          <div className="col-span-12 space-y-8 lg:col-span-6">
            <PreviewTabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
            <PreviewContent activeTab={activeTab} />
          </div>
          <div className="col-span-12 lg:col-span-3">
            <DownloadSidebar />
          </div>
        </div>
      </div>
    </section>
  );
}